import React, {Component} from 'react';

import { cf } from './c_20210415a_YSh/cf';
import { ce } from './c_20210415a_YSh/ce';
import { iv } from './c_20210415a_YSh/iv';
import { ic } from './c_20210415a_YSh/ic';
import { cp } from './c_20210415a_YSh/cp';
import { ip } from './c_20210415a_YSh/ip';
import { bf } from './c_20210415a_YSh/bf';

import cView from './c_20210415a_YSh/cView';

class iMthList extends cView { // monthly list

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stss = {
    sld_it60ss: {},
  };

  $ilp_loads = () => [
    ip.$ip_load_it60({
      mode: 'items',
      state: 'sld_it60ss',
//      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      cm20_key: global.c?.state.sgcd_pageCmns?.cm20_key,
      ld_sortss: [{fld:'it60d110', dtn:'asc'}],
    }),
  ];
  
  render() {
    //
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_sch={false}
        onSchEnt={null}
        rhtIconName='plus'
        rhtPfx='追加'
        onRhtPrs={()=>{
          let _d_pageInfs = {
            sgc_pageRole: global.c?.state.sgc_pageRole,
            sgc_pageName: 'iMthDtl',
            sgc_pageMode: 'new',
          };
          cf.myRN_move_fwd(_d_pageInfs);
        }}
        d_hdrs={{
          pfx: iv._get_hdrPfx('月別一覧'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            ld_iss: [
              ip.dd_rptss['月別一覧CSV'],
              ip.dd_rptss['月別時間帯別一覧CSV'],
            ],
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type: 'List',
              pfx: '',
              state: 'sld_it60ss',
              nextRole: global.c?.state.sgc_pageRole,
              nextPage: 'iMthDtl',
              nextMode: 'show',
              keyName: 'it60_key',
              b_edt: false,
              b_img: false,
              b_bdr: false,
            },
          ],
        }}
      />
    );
  }
}

export default iMthList;
